import React from 'react'
import deepEqual from 'fast-deep-equal'
import { editor } from '../editor.local.methods'

const directions = {
    up: 'bottom',
    left: 'right',
    down: 'top',
    right: 'left',
}

const getMarqueeTranslate = (position) => `translate(${position.x}px, ${position.y}px)`
const getPosition = (p_) => ({
    width: p_.width,
    height: p_.height,
    left: p_.left,
    top: p_.top,
})

class EditorItemLocalMethods extends React.Component {
    state = {
        name: this.props.name,
        active: [],
        played: 0,
        volume: this.props.volume,
        ready: false,
        error: false,
        position: getPosition(this.props),
        isShowVideoBar: false,
    }
    textFileTypes = ['text', 'xml', 'csv', 'rss']
    feedInterval = null
    marquee = {}

    componentDidUpdate(prevProps) {
        const p_ = this.props

        this.setItemPosition(prevProps)
        this.startFeedAnimation(prevProps)

        if (p_.name !== prevProps.name) {
            this.setState({ name: p_.name })
        }
        if (p_.volume !== prevProps.volume) {
            this.setState({ volume: p_.volume })
        }

        if (this.containerRef) {
            const p_ = this.props
            const containerWidth = this.canvasWrapperRef.offsetWidth
            const containerHeight = this.canvasWrapperRef.offsetHeight
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
            svg.setAttribute('width', containerWidth)
            svg.setAttribute('height', containerHeight)
            svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink')
            const svgns = 'http://www.w3.org/2000/svg'

            svg.style.strokeWidth = p_.style.strokeWidth
            svg.style.fill = p_.style.fill
            svg.style.stroke = p_.style.stroke

            if (p_.pictogramName === 'rectangle') {
                const newRect = document.createElementNS(svgns, 'rect')
                newRect.setAttribute('x', '0')
                newRect.setAttribute('y', '0')
                newRect.setAttribute('width', containerWidth)
                newRect.setAttribute('height', containerHeight)
                newRect.setAttributeNS(null, 'rx', p_.style.rx || '0')
                svg.appendChild(newRect)
            }
            if (p_.pictogramName === 'circle') {
                const newCircle = document.createElementNS(svgns, 'circle')
                newCircle.setAttribute('cx', '50%')
                newCircle.setAttribute('cy', '50%')
                newCircle.setAttribute(
                    'r',
                    (containerHeight > containerWidth
                        ? containerWidth / 2 - svg.style.strokeWidth / 2
                        : containerHeight / 2 - svg.style.strokeWidth / 2
                    ).toString()
                )
                svg.appendChild(newCircle)
            }

            if (p_.style && p_.style.content) {
                const textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text')
                const text = document.createTextNode(p_.style.content)
                textElement.setAttribute('x', '50%')
                textElement.setAttribute('y', '50%')
                textElement.setAttribute('dominant-baseline', 'middle')
                textElement.setAttribute('text-anchor', 'middle')
                textElement.setAttribute('stroke-width', '0')
                textElement.setAttribute('fill', p_.style.color ? p_.style.color : '#000000')
                textElement.setAttribute('font-size', p_.style.fontSize ? p_.style.fontSize : 18)
                textElement.style.fontWeight = '400'
                textElement.appendChild(text)
                svg.appendChild(textElement)
            }

            const s = new XMLSerializer()
            const str = s.serializeToString(svg)

            this.containerRef.innerHTML = str

            //поставил проверку чтобы не падало при сдвиге таймлиний
            if (p_.body !== str && typeof editor.setSvgBody === 'function') {
                editor.setSvgBody(p_.areaIndex, p_.contentIndex, str)
            }
        }

        if (this.textContentRef) {
            this.textContentRef.style.setProperty(
                'font-family',
                p_.style && this.props.data.style.fontFamily ? this.props.data.style.fontFamily : 'inherit',
                'important'
            )
        }
    }

    componentWillUnmount() {
        this.clearFeedInterval()
    }

    startFeedAnimation = () => {
        const p_ = this.props

        if (this.canStartFeedAnimation(p_)) {
            this.clearFeedInterval()
            this.startFeedInterval()
        }
    }

    setItemPosition = (prevProps) => {
        const nextProps = this.props
        const prevPosition = getPosition(prevProps)
        const nextPosition = getPosition(nextProps)

        if (!deepEqual(prevPosition, nextPosition)) {
            this.setState({ position: nextPosition })
        }
    }

    onResize = (position, direction) => {
        const p_ = this.props

        if (p_.fileType === 'web_app') {
            this.setState({ position })
        }

        p_.onResize(position, direction)
    }

    canStartFeedAnimation = (p_) => {
        if (!this.textFileTypes.includes(p_.fileType)) {
            return false
        }

        if (!(p_.data && p_.data.settings && p_.data.settings.marquee)) {
            return false
        }

        const marquee = p_.data.settings.marquee

        const feedData = {
            areaWidth: this.wrapperRef.offsetWidth,
            areaHeight: this.wrapperRef.offsetHeight,
            speed: marquee.speed,
            direction: marquee.direction,
        }

        if (!deepEqual(this.marquee, feedData)) {
            this.marquee = feedData
            return true
        }

        return false
    }
    startFeedInterval = () => {
        if (this.marquee.direction === 'disabled') {
            return
        }

        this.textContentRef.style.width = 'auto'
        this.textContentRef.style.whiteSpace = 'nowrap'

        const marqueeWidth = this.textContentRef.offsetWidth
        const marqueeHeight = this.textContentRef.offsetHeight

        const options = {
            iterationCount: 1000,
            width: this.marquee.areaWidth,
            height: this.marquee.areaHeight,
            marqueeHeight,
            marqueeWidth,
        }

        const speed = this.marquee.speed * 0.5
        options.deltaX = (options.width * speed) / options.iterationCount
        options.deltaY = (options.height * speed) / options.iterationCount

        this.moveMarquee(options)
    }
    moveMarquee = (options) => {
        const position = {
            x: options.marqueeWidth,
            y: 0,
        }

        if (this.marquee.direction === 'right') {
            position.x = -options.marqueeWidth
        }

        if (this.marquee.direction === 'up') {
            position.x = 0
            position.y = options.marqueeHeight
        }

        if (this.marquee.direction === 'down') {
            position.x = 0
            position.y = -options.marqueeHeight
        }

        this.initMarqueeStyles(position)

        this.feedInterval = setInterval(() => {
            if (this.marquee.direction === 'left') {
                if (position.x < options.width * -1) {
                    position.x = options.marqueeWidth
                }
                position.x -= options.deltaX
            }
            if (this.marquee.direction === 'up') {
                if (position.y < options.height * -1) {
                    position.y = options.marqueeHeight
                }
                position.y -= options.deltaY
            }

            if (this.marquee.direction === 'right') {
                if (position.x > options.width) {
                    position.x = -options.marqueeWidth
                }
                position.x += options.deltaX
            }
            if (this.marquee.direction === 'down') {
                if (position.y > options.height) {
                    position.y = -options.marqueeHeight
                }
                position.y += options.deltaY
            }
            if (this.textContentRef) {
                this.textContentRef.style.transform = getMarqueeTranslate(position)
            }
        }, 10)
    }
    initMarqueeStyles = (position) => {
        const direction = directions[this.marquee.direction]
        const styles = {
            position: 'absolute',
            top: 'initial',
            left: 'initial',
            right: 'initial',
            bottom: 'initial',
            [direction]: 0,
            transform: getMarqueeTranslate(position),
        }

        Object.assign(this.textContentRef.style, styles)
    }
    clearFeedInterval = () => {
        if (this.textContentRef) {
            Object.assign(this.textContentRef.style, this.getTextContentStyles())
        }

        clearInterval(this.feedInterval)
    }
    textOrientationCheck = () => {
        const p_ = this.props
        return (
            p_.data &&
            p_.data.settings &&
            p_.data.settings.textOrientation &&
            p_.data.settings.textOrientation === 'vertical'
        )
    }
    getTextContentStyles = (text) => {
        const p_ = this.props

        const styles = {
            fontFamily: 'inherit',
            fontSize: p_.data && p_.data.style ? p_.data.style.size + 'px' : `${100 * p_.scale}%`,
            position: 'relative',
            transform: 'none',
            whiteSpace: 'normal',
            textDecoration:
                p_.data && p_.data.settings.marquee.direction !== 'disabled' && p_.data.style.underline
                    ? 'underline'
                    : 'none',
            writingMode: this.textOrientationCheck() && 'vertical-lr',
            textOrientation: this.textOrientationCheck() && 'upright',
        }

        if (text && !text.includes(' ')) {
            styles.wordBreak = 'break-all'
        }

        return styles
    }

    // video/audio players
    onReactPlayerEnded = () => {
        this.setState({ active: [], played: 0 })
    }
    onReactPlayerProgress = (e) => {
        if (e.played < 1) {
            this.setState({ played: e.played })
        }
    }
    onReactPlayerReady = () => {
        this.setState({ ready: true, error: false })
    }
    onReactPlayerError = () => {
        this.setState({ error: true, ready: false })
    }
    showVideoBar = () => {
        this.setState({ isShowVideoBar: true })
    }
    hideVideoBar = () => {
        this.setState({ isShowVideoBar: false })
    }
}

export default EditorItemLocalMethods
